import _get from 'lodash/get';

function itemListToMapId(itemList) {
  return itemList.reduce((itemMap, item) => ({
      ...itemMap,
      [item._id]: item,
    }), {});
}


export default (payload) => {
  const menu = _get(payload, 'fishermanBusiness.menu');
  if (menu) {
    // Check if menu is a URL (string)
    if (typeof menu === 'string') {
      return menu;
    }

    const categories = itemListToMapId(menu.categories);
    const items = itemListToMapId(menu.items);
    const modifierSets = itemListToMapId(menu.modifierSets);
    const modifiers = itemListToMapId(menu.modifiers);

    return {
      "@type": "Menu",
      // One section per schedule
      hasMenuSection: menu.schedules.map(schedule => {
        return {
          "@type": "MenuSection",
          name: schedule.name,

          // TODO: discuss and define how schedule times should be set
          // offers: {
          //   "@type": "Offer",
          //   availabilityEnds: "T8:22:00",
          //   availabilityStarts: "T8:22:00"
          // },

          // One sub-section per menu category
          hasMenuSection: schedule.categories.map(categoryId => {
            const category = categories[categoryId];
            return {
              "@type": "MenuSection",
              name: category.name,
              hasMenuItem: category.items.map(itemId => {
                const item = items[itemId];
                return {
                  "@type": "MenuItem",
                  name: item.name,
                  description: item.description,
                  offers: item.variations.map(variation => ({
                    "@type": "Offer",
                    name: variation.name,
                    price: variation.price,
                    priceCurrency: "USD"
                  })),
                  menuAddOn: item.modifierSets.reduce((menuAddOnList, modifierSetId) => {
                    const modifierSet = modifierSets[modifierSetId];
                    const menuAddOnInSet = modifierSet.modifiers.map(modifierId => {
                      const modifier = modifiers[modifierId];
                      return {
                        "@type": "MenuItem",
                        name: modifier.name,
                        description: modifierSet.name,
                        offers:{
                          "@type": "Offer",
                          price: modifier.price,
                          priceCurrency: "USD"
                        }
                      }
                    });
                    return menuAddOnList.concat(menuAddOnInSet);
                  }, []),
                }
              }),
            }
          })
        };
      })
    };
  }

  return undefined;
};
